/* uhm-popup.js — shows the B2B prompt on matching URLs, once per N days, after a delay or scroll depth. No dependencies. */
(function () {
  'use strict';
  var el = document.querySelector('[data-uhm-popup]');
  if (!el) return;
  // Draft gate: with preview_only on, the prompt only runs on unpublished themes (theme preview), never on the live one.
  if (el.getAttribute('data-preview-only') === 'true' && window.Shopify && Shopify.theme && Shopify.theme.role === 'main') return;
  var key = el.getAttribute('data-key') || 'uhm_b2b_popup_v1';
  var days = parseInt(el.getAttribute('data-days') || '7', 10);
  var delay = parseInt(el.getAttribute('data-delay') || '20', 10) * 1000;
  var scrollPct = parseInt(el.getAttribute('data-scroll') || '40', 10);
  var paths = (el.getAttribute('data-paths') || '').split(/\s+/).map(function (p) { return p.trim(); }).filter(Boolean);
  var here = window.location.pathname.replace(/^\/(es|fr|de|es-us)(\/|$)/, '/');

  function matches() {
    if (!paths.length) return false;
    return paths.some(function (p) {
      if (p.indexOf('*') === -1) return here.indexOf(p) === 0;
      var re = new RegExp('^' + p.split('*').map(function (s) { return s.replace(/[.+?^${}()|[\]\\]/g, '\\$&'); }).join('.*'));
      return re.test(here);
    });
  }
  function seen() {
    try { var t = parseInt(localStorage.getItem(key) || '0', 10); return t && (Date.now() - t) < days * 864e5; } catch (e) { return false; }
  }
  function mark() { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
  function push(ev, extra) {
    try { window.dataLayer = window.dataLayer || []; var p = { event: ev, uhm_article: here }; for (var k in extra) p[k] = extra[k]; window.dataLayer.push(p); } catch (e) {}
  }
  // Review helpers: ?uhm_popup=1 shows it right away on any URL; on an unpublished theme (preview) it ignores the once-per-N-days memory.
  var force = /[?&]uhm_popup=1(&|$)/.test(window.location.search);
  var preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  if (force) delay = 800;
  if (!force && (!matches() || (!preview && seen()))) return;

  var shown = false;
  var waited = 0;
  function lockedByOther() {
    if (document.documentElement.classList.contains('uhm-popup-open')) return false;
    return getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
  }
  function show() {
    if (shown) return;
    if (!force && waited < 15000 && lockedByOther()) { waited += 1000; setTimeout(show, 1000); return; }
    shown = true;
    el.hidden = false;
    document.documentElement.classList.add('uhm-popup-open');
    mark();
    push('uhm_b2b_cta_view', { uhm_position: 'popup' });
    var first = el.querySelector('[data-uhm-popup-cta]');
    if (first) first.focus({ preventScroll: true });
  }
  function hide() { el.hidden = true; document.documentElement.classList.remove('uhm-popup-open'); }

  var timer = setTimeout(show, delay);
  function onScroll() {
    var doc = document.documentElement;
    var total = doc.scrollHeight - window.innerHeight;
    if (total > 0 && (window.scrollY / total) * 100 >= scrollPct) { clearTimeout(timer); show(); window.removeEventListener('scroll', onScroll); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  Array.prototype.forEach.call(el.querySelectorAll('[data-uhm-popup-close]'), function (b) {
    b.addEventListener('click', function () { hide(); push('uhm_b2b_popup_dismiss'); });
  });
  // click on the dimmed backdrop (outside the card) closes it
  el.addEventListener('click', function (e) { if (e.target === el) { hide(); push('uhm_b2b_popup_dismiss', { uhm_via: 'backdrop' }); } });
  var cta = el.querySelector('[data-uhm-popup-cta]');
  if (cta) cta.addEventListener('click', function () { push('uhm_b2b_cta_click', { uhm_position: 'popup', uhm_href: cta.getAttribute('href') }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) { hide(); push('uhm_b2b_popup_dismiss'); } });
})();
